import { useEffect, useCallback } from 'react';

const useSetShipmentStatus = (
  shipmentsStepCompleted: boolean,
  isSlotRequired: boolean,
  dynamicStatus: boolean,
  setStepShipmentsStatus: (flag: boolean) => any
): void => {
  const staticUpdate = useCallback(() => {
    if (!shipmentsStepCompleted) {
      setStepShipmentsStatus(true);
    }
  }, [shipmentsStepCompleted, setStepShipmentsStatus]);

  const dynamicUpdate = useCallback(() => {
    if (shipmentsStepCompleted !== dynamicStatus) {
      setStepShipmentsStatus(dynamicStatus);
    }
  }, [shipmentsStepCompleted, dynamicStatus, setStepShipmentsStatus]);

  useEffect(() => {
    // No Delivery Slot dependency, hence set Shipment step to "complete" already!
    if (!isSlotRequired) {
      staticUpdate();
    } else {
      dynamicUpdate();
    }
  }, [isSlotRequired, staticUpdate, dynamicUpdate]);
};

export default useSetShipmentStatus;
